export const removeLiValueAttributes = (html: string): string => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');

    const liElements = doc.querySelectorAll('li[value]');
    liElements.forEach(li => {
        li.removeAttribute('value');
    });

    return doc.body.innerHTML;
};
